import { render, staticRenderFns } from "./MenuSegments.vue?vue&type=template&id=04770724&"
import script from "./MenuSegments.vue?vue&type=script&lang=js&"
export * from "./MenuSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports